import React, { Component } from 'react'
import Bulletin from '../../components/grid/gallery'
import whitepaper1 from '../../assets/image/whitepaper/whitepaper1.png'
import './css/index.css'
import Download from '../../assets/image/Download.svg'
import Navbar from '../../components/navbar'
import Footer from '../../components/footer'
import './css/index.css'
import Logo from '../../assets/image/onegml.png'
import HeadPage from '../../components/header'
import {data_bulletin} from '../../dummy/data'
import GridBulletin from '../../components/grid/bulletin'
export default class index extends Component {

    render() {
        return (
            <div>
                <Navbar/>
                <br/><br/><br/><br/><br/>
                <section className='paper-page'>
                    <HeadPage title='Knowledge Bulletin' subtitle='Check out our latest thinking' is_filter={false}/>
                    <hr/>
                    <br/>
                    {/* <div className='whitepaper-grid'>
                        {data_whitepaper.map((data,i)=>(
                            <div className='whitepaper-overlay'>
                                <img src={data.img}/>
                                <div className='request-copy' onClick={this.toggleRequest}>
                                    <div style={{display:'flex',justifyContent:'center',alignItems:'center'}}>
                                    <img src={Download} style={{width:15}}/>
                                    <p>request copy</p>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div> */}
                    <GridBulletin data={data_bulletin}/>
                </section>
               <br/>
                <Footer/>
            </div>
        )
    }
}
